import {URL_ROLE, fetchBody, body2String, URL_ROLE_GETPERMISSION, URL_ROLE_SETPERMISSION, URL_ACCOUNT_GET_CLIENTADMIN_LISTPAGE, URL_ACCOUNT_GET_CLIENTADMIN_LIST, URL_ACCOUNT_ADD_CLIENTADMIN, URL_ACCOUNT_GET_CLIENTADMIN_DETAIL, URL_ACCOUNT_UPDATE_CLIENTADMIN, URL_ROLE_GET_CLIENTADMIN_LIST} from "../config"
import { toFetch, toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export const rigister = (token, fn) => {
  if(token === ""){
    toLogout(false);
  }else{
    var obj = {
      token:token,
    }
    toFetch(obj, URL_ROLE+"getAdminList", fn)
    fetch(URL_ROLE+"getAdminList", 
      fetchBody(body2String(obj))
    )
    .then((response) => {
        //console.log(response);
      return response.json();
    }).then((jsonDate)=>{
      //console.log("jsonDate :")
      fn(true, jsonDate);
    }).catch((err)=>{
      console.log("錯誤 :", err)
      fn(false);
    })
  }
  return;
}

/**
 * 管理員列表
 * @param {*} token 
 * @param {*} start 
 * @param {*} limit 
 * @param {*} fn 
 */
export const getClientAdminList = ({success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_ACCOUNT_GET_CLIENTADMIN_LIST, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate, jsonDate.menus)
      }, 
      failure
    })
  }
}

/**
 * 管理員列表 (分頁)
 * @param {*} token 
 * @param {*} start 
 * @param {*} limit 
 * @param {*} fn 
 */
export const getClientAdminListPage = async ({mReqClientAdminListPage, success, failure}) => {
  var token = getToken();
  //console.log(fetchBody({body: mReqManagerListPage, token}))
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqClientAdminListPage, token}), 
      url: URL_ACCOUNT_GET_CLIENTADMIN_LISTPAGE, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate, jsonDate.menus)
        return jsonDate
      }, 
      failure
    })
  }
}


export const getAdminRole = ({success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
  cleanFetch({
    body: fetchBody({token}), 
    url: URL_ROLE_GET_CLIENTADMIN_LIST, 
    success:(jsonDate)=>{
      //var menu = analysisMenu(jsonDate.menus);
      console.log(jsonDate)
      success(jsonDate, jsonDate.menus)
    }, 
    failure
  })
  }
  return;
}

export const getPermission = ({roleId, success, failure}) =>{
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    
    cleanFetch({
      body: fetchBody({body: {roleId}, token}), 
      url: URL_ROLE_GETPERMISSION, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate, jsonDate.menus)
      }, 
      failure
    })
  }
}

export const setPermission = ({mReqPermission, success, failure}) =>{
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqPermission, token}), 
      url: URL_ROLE_SETPERMISSION, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
}

export const api_addClientAdmin = ({mReqClientAdminAdd, success, failure}) =>{
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqClientAdminAdd, token}), 
      url: URL_ACCOUNT_ADD_CLIENTADMIN, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
}

export const api_getClientAdminDetail = ({accountId, success, failure}) =>{
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    console.log("api_getAdminDetail")
    cleanFetch({
      body: fetchBody({body: {accountId}, token}), 
      url: URL_ACCOUNT_GET_CLIENTADMIN_DETAIL, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
}

export const api_updateClientAdmin = ({mReqClientAdminEdit, success, failure}) =>{
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    console.log("api_updateClientAdmin")
    cleanFetch({
      body: fetchBody({body: mReqClientAdminEdit, token}), 
      url: URL_ACCOUNT_UPDATE_CLIENTADMIN, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
}